import { dbPost, dbPut, dbDelete } from '../../apis/commonApi';
class TaskController {
  headerList = [
    {
      colNo: 0,
      key: 'selected',
      labelType: 'check',
      dataType: 'check',
      name: '선택',
      readonly: false,
    },
    {
      colNo: 1,
      key: 'seq',
      labelType: 'text',
      dataType: 'text',
      name: '순번',
      readonly: true,
    },
    {
      colNo: 2,
      key: 'processName',
      labelType: 'text',
      dataType: 'inputText',
      name: '작업명',
      readonly: false,
      maxLength: 6,
    },
    {
      colNo: 3,
      key: 'processExpln',
      labelType: 'text',
      dataType: 'inputText',
      name: '작업 상세내용',
      readonly: false,
      maxLength: 333,
    },
  ];

  constructor(
    store,
    modalService,
    validateService,
    tableRef,
    navigate,
    [searchParam, setSearchParam],
    {
      valueObj,
      setValueObj,
      dataList,
      setDataList,
      deletedRows,
      setDeletedRows,
    }
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.tableRef = tableRef;
    this.navigate = navigate;
    this.searchParam = searchParam;
    this.setSearchParam = setSearchParam;
    this.valueObj = { ...valueObj };
    this.setValueObj = setValueObj;
    this.dataList = dataList || [];
    this.setDataList = setDataList;
    this.deletedRows = deletedRows;
    this.setDeletedRows = setDeletedRows;
  }

  async init() {
    await this.setSearchParam({
      entSn: this.store.entSn,
      currentPage: 1,
      pageSize: 10,
    });
    this.loadTaskOptions();
  }

  //공정 리스트
  async loadTaskOptions(currentPage = 1) {
    const validationRules = {
      entSn: { presence: true },
    };

    const altKey = {
      entSn: '기업',
    };

    if (
      await this.validateService.validateJsCall(
        this.searchParam,
        validationRules,
        altKey
      )
    ) {
      return;
    }

    const url = '/aia/process/info.do';

    let response = await dbPost(url, { ...this.searchParam, currentPage });
    if (response && Array.isArray(response)) {
      const updatedValueObj = { taskOptions: response }; // response를 valueObj에 추가
      this.setValueObj(prev => ({ ...prev, ...updatedValueObj })); // 업데이트
    }
  }

  //작업 리스트
  async loadWorkOptions(taskId) {
    const url = '/aia/task/work.do';
    const param = { taskId: taskId };

    let response = await dbPost(url, param);
    if (response && Array.isArray(response)) {
      const updatedDataList = response.map((item, index) => ({
        totalCount: item.totalCount,
        seq: index + 1, // Start from 1 instead of 0
        rowNo: item.rowNo,
        workId: item.workId, // workId 추가
        processName: item.workNm,
        processExpln: item.workDesc,
        selected: false,
      }));
      this.setDataList(updatedDataList);
      if (this.tableRef.current) {
        this.tableRef.current.resetData(updatedDataList);
      }
    }
  }

  // 작업 행 추가
  addWorkRow() {}

  // 작업 행 삭제
  deleteWorkRows() {
    const tempDatas = this.tableRef.current.getDataList();

    let deleteList = [];

    for (let i = 0; i < tempDatas.length; i++) {
      const item = tempDatas[i];

      if (item.selected === true) {
        deleteList.push(item);
      }
    }

    const doDelete = async () => {
      const url = '/aia/task/remove.do';

      let response;

      try {
        response = await dbPost(url, { deleteList: deleteList });

        if (response instanceof Error) {
          this.modalService.errorAlert('삭제 중 오류가 발생했습니다.');
        } else {
          this.modalService.successAlert('삭제되었습니다.');
          this.loadWorkOptions(this.valueObj?.taskId);
        }
      } catch (error) {
        this.modalService.errorAlert('삭제 중 오류가 발생했습니다.');
      }
    };

    if (deleteList.length === 0) {
      this.modalService.errorAlert('삭제할 행을 선택해 주세요.');
    } else {
      this.modalService.confirmAlert(
        { msg: '삭제하시겠습니까? 저장되지 않은 행은 삭제됩니다.' },
        [
          () => {
            doDelete();
          },
          () => {},
        ]
      );
    }
  }

  // 저장하기
  async saveChanges() {
    try {
      // 삭제된 행에 대해 DELETE 요청
      if (this.deletedRows.length > 0) {
        for (const row of this.deletedRows) {
          await dbPost('/aia/task/remove.do', { workId: row.workId });
        }
      }

      // 추가된 행에 대해 POST 요청
      const addedRows = this.dataList.filter(row => !row.workId);

      if (addedRows.length > 0) {
        for (const row of addedRows) {
          if (!row.processName || !row.processExpln) {
            this.modalService.errorAlert('모든 필수 정보를 입력해 주세요.');
            return;
          }
          let result = await dbPost('/aia/task/add.do', {
            taskId: this.valueObj.taskId,
            workNm: row.processName,
            workDesc: row.processExpln,
          });

          if (result instanceof Error) {
            this.modalService.errorAlert('저장 중 오류가 발생했습니다.');
            return;
          } else {
            this.loadWorkOptions(this.valueObj?.taskId);
            this.navigate('/ai/process');
          }
        }
      }

      // 업데이트된 행에 대해 PUT 요청
      const updatedRows = this.dataList.filter(
        row =>
          row.workId &&
          !this.deletedRows.some(deletedRow => deletedRow.workId === row.workId)
      );

      if (updatedRows.length > 0) {
        for (const row of updatedRows) {
          if (!row.processName || !row.processExpln) {
            this.modalService.errorAlert('모든 필수 정보를 입력해 주세요.');
            return;
          }
          let result = await dbPost('/aia/task/modify.do', {
            workId: row.workId,
            workNm: row.processName,
            workDesc: row.processExpln,
          });

          if (result instanceof Error) {
            this.modalService.errorAlert('저장 중 오류가 발생했습니다.');
            return;
          } else {
            this.loadWorkOptions(this.valueObj?.taskId);
          }
        }
      }

      // 성공적으로 저장된 후 배열 초기화
      this.setDeletedRows([]);
      this.modalService.successAlert('변경 사항이 성공적으로 저장되었습니다.');
    } catch (error) {
      this.modalService.errorAlert('저장 중 오류가 발생했습니다.');
    }
  }

  // valueObj 변경
  async valueObjChange(model, value) {
    this.setValueObj(prev => ({ ...prev, [model]: value }));
  }
}

export default TaskController;
